.Header {
    padding: 15px;
    background: var(--hps-white);
    color: #000000;
    display: flex;
    justify-content: center;
}
.HeaderRight {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.menuClosed {
    cursor: pointer;
    display: flex;
    align-items: center;
}

.menuOpen {
    display: none;
}